module.exports = __webpack_public_path__ + "static/img/experiment-lab.af8ccc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/default/lab/experiment-lab.jpg
// module id = zniL
// module chunks = 2